// extracted by mini-css-extract-plugin
module.exports = {"signpadcontainer":"signpad_signpadcontainer__2ZsP5","signpad":"signpad_signpad__3lQus","clear":"signpad_clear__3Mrq5"};